import { Text } from "@/components/ui/baseUi/text"
import { GlobeIcon } from "@images/svgIcons/globeIcon"
import { LockIcon } from "@images/svgIcons/lockIcon"
import {
  ExploreBenchmarkItemEntity,
  ExploreBoxItemEntity,
  ExploreProgramBundleItemEntity,
  ExploreProgramItemEntity,
  ExploreProProgramItemEntity,
} from "@modules/explore/entities/exploreEntity"
import { ExploreFilter } from "@modules/explore/exploreTypes"
import { ProgramVisibility } from "@modules/programs/types/programTypes"
import { getDisplayVisibility, getSubscriptionCountText } from "@modules/programs/utils/programUtils"
import { useMemo } from "react"

type ExploreCardTitleProps = {
  item:
    | ExploreBenchmarkItemEntity
    | ExploreProgramItemEntity
    | ExploreProgramBundleItemEntity
    | ExploreBoxItemEntity
    | ExploreProProgramItemEntity
}

export function ExploreCardTitle({ item, ...props }: ExploreCardTitleProps & React.ComponentProps<"div">) {
  const itemTitle = useMemo(() => {
    switch (item._type) {
      case ExploreFilter.PROGRAM:
      case ExploreFilter.PROGRAM_BUNDLE:
      case ExploreFilter.PROGRAM_PRO:
        return item.name
      case ExploreFilter.BOX:
        return item.name
      case ExploreFilter.BENCHMARK:
        return item.title
    }
  }, [item])

  return (
    <div className="flex flex-col" {...props}>
      {(item._type === ExploreFilter.BOX ||
        item._type === ExploreFilter.PROGRAM ||
        item._type === ExploreFilter.PROGRAM_PRO ||
        item._type === ExploreFilter.PROGRAM_BUNDLE) && (
        <>
          <Text fontStyle="TL" className="line-clamp-2 text-textOnColor-body">
            {itemTitle}
          </Text>
          {(item instanceof ExploreProgramItemEntity ||
            item instanceof ExploreProgramBundleItemEntity ||
            item instanceof ExploreProProgramItemEntity) && (
            <div className="flex items-center">
              <Text fontStyle="LL" className="text-textOnColor-body">
                {`${getSubscriptionCountText(item.subscriptionCount, false, false, true, item.programType).toLowerCase()} - `}
              </Text>
              {item.visibility === ProgramVisibility.PUBLIC ? (
                <GlobeIcon color="currentColor" className="ml-2 text-textOnColor-body" />
              ) : (
                <LockIcon color="currentColor" className="ml-2 text-textOnColor-body" />
              )}
              <Text fontStyle="BM" className="ml-2 text-textOnColor-body">
                {getDisplayVisibility(item.visibility)}
              </Text>
            </div>
          )}
        </>
      )}
      {item._type === ExploreFilter.BENCHMARK && (
        <div className="flex flex-col pb-2">
          <Text fontStyle="LM" className="text-textDefault-body">
            {item.category}
          </Text>
          <Text fontStyle="HL" className="text-textDefault-body">
            {itemTitle}
          </Text>
        </div>
      )}
    </div>
  )
}
